module.exports = ".yeti-tabs .yeti-results {\n  box-shadow: none; }\n\nyeti-tabs .yeti-tab-menu-phone {\n  padding: 5px 10px;\n  padding-bottom: 0; }\n  yeti-tabs .yeti-tab-menu-phone .yeti-button-primary-inverse {\n    border-bottom: 1px solid #ffffff;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    display: block;\n    margin: 0;\n    position: relative;\n    top: 1px;\n    width: 100%; }\n  yeti-tabs .yeti-tab-menu-phone .yeti-menu-body {\n    left: 0;\n    right: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/tab-menu/tab-item.component.scss
// module id = 644
// module chunks = 0